<template>
  <gh-tabs-page v-model="activatedTab" :tabs="tabs" :show-tabs="showTabs">
    <template #tab0-left-drawer>
      <slot name="area_left"></slot>
    </template>

    <template #tab0="{index,item}">
      <gh-dialog ref="editDialog" :model-props="editProps">
        <template v-slot="{model,props}">
          <slot name="area_edit" :model="model" :props="props">

          </slot>
        </template>
        <template v-slot:[getModelTemplateName(item)]="{prop,model}" v-for="item in editProps">
          <slot :name="getModelTemplateName(item)" :prop="prop" :model="model">

          </slot>
        </template>
      </gh-dialog>
      <gh-data-table ref="table" v-model="selectedItems" :before-intial="beforeRowIntial" :current-model="currentModel"
        :pagination.sync="pagination" :loading="loading" :items="items" :tableConfig.sync="tableConfig"
        :events.sync="tableEvents" :total-items="totalItems" :table-id="tableId">
        <template #query_condition>
          <slot name="area_query">
          </slot>

        </template>
        <template #toolbar>
          <v-spacer>
          </v-spacer>
          <v-layout row justify-end align-baseline>
            <slot name="area_operation_before">

            </slot>
            <slot name="area_operation">
              <v-btn color="primary" @click="query()">刷新</v-btn>
              <gh-import :tableId='tableId' @on-success-upload='onSuccessUpload'/>
              <custorm-query :headers="headers" @submit="submitCustomQuery">
              </custorm-query>
              <slot name="area_operation_new" :addItem="addItem">
                <v-btn color="success" @click="addItem">新增</v-btn>
              </slot>
              <v-btn v-show="selectedItems.length>1" color="error" @click="deleteItems">删除</v-btn>
            </slot>
            <slot name="area_operation_after"></slot>
          </v-layout>


        </template>
        <template v-slot:[getCellTemplateName(item)]="{props}" v-for="item in headers">
          <slot :name="getCellTemplateName(item)" :props="props"></slot>
        </template>

      </gh-data-table>

    </template>
    <template #tab1="{index,item}">
      <slot name="area_detail" :current="currentModel" :props="editProps">
        <slot name="area_detail_pre" :current="currentModel"></slot>
        <gh-model-view :model="currentModel" :props="editProps" :readonly="true">
          <template #title>
          </template>
          <template #actions>
          </template>
          <template v-slot:[getModelTemplateName(item)]="{prop,model}" v-for="item in headers">
            <slot :name="'view-prop-'+prop.value" :prop="prop" :model="model" :readonly="true"></slot>
          </template>
        </gh-model-view>
        <slot name="area_detail_after" :current="currentModel"></slot>
      </slot>
    </template>

  </gh-tabs-page>
</template>

<style scoped>

</style>

<script>
  import GhTablePage from "./ghTablePage.ts";
  export default GhTablePage;
</script>